import { useEffect, useRef, useState } from 'react'

import Machines from '@/components/MachinesV2'
import TapTonMachine from '@/components/PlansWithTapTon/TapTonMachine'
import { useAmplitude } from '@/contexts/AmplitudeProvider'
import { useTonPlans } from '@/contexts/plans'
import { GlobalConfig } from '@/types/cms'
import { formaterStringWithHTML } from '@/utils/formaterStringWithHTML'
import { trackSectionViewAnalyticsEvent } from '@/utils/trackSectionViewAnalyticsEvent'

export type themeProps =
  | 'default'
  | 'no-carousel-web-two-cards'
  | 'all-products'

interface AllMachinesDetailedProps {
  referId: string
  title: string
  description?: string
  globalConfig?: GlobalConfig
  themeLayout: themeProps
}

export function AllMachinesDetailed({
  referId,
  title,
  description,
  globalConfig,
  themeLayout = 'default'
}: AllMachinesDetailedProps) {
  const { currentPlan } = useTonPlans()
  const { analytics } = useAmplitude()
  const ref = useRef<HTMLDivElement>(null)
  const [showComponent, setShowComponent] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !showComponent) {
          trackSectionViewAnalyticsEvent(
            analytics,
            'section viewed ton',
            formaterStringWithHTML(title)
          )
          setShowComponent(true)
        }
      },
      {
        threshold: 0.5
      }
    )

    const currentRef = ref.current
    if (currentRef) {
      observer.observe(currentRef)
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showComponent])

  if (!currentPlan) return null

  return (
    <div ref={ref} id={referId}>
      {currentPlan.type === 'tap_phone' ? (
        <TapTonMachine />
      ) : (
        <Machines
          title={title}
          description={description}
          promotionalTag={globalConfig?.promotionalTag}
          themeLayout={themeLayout}
        />
      )}
    </div>
  )
}
